if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

var theme = theme || {};
theme.MealPlanSet = (function() {

  function MealPlanSet(container, activeWeek, mealPlan, calories, min_meals, mealPlanTitle, dinnersOnly) {
    this.container = container;
    this.$container = $(container); // For jQuery
    this.productInfo = JSON.parse(document.getElementById('productInfo').innerHTML);
    this.subscriptions = this.productInfo['subscription_products'];
    this.mealPlan = mealPlan;
    this.mealPlanTitle = mealPlanTitle.indexOf('-') > -1 ? mealPlanTitle.split(' - ')[0] : '';
    this.calories = parseInt(calories, 10) || null;
    this.$mealList = $('.meal__list');
    this.min_meals = min_meals || 5;
    this.meal_count = 0;
    this.max_meals = 15;
    this.addMealPlanBtn = document.querySelector('.btn--add-to-cart');
    this.addIcon = document.getElementById('addIcon').innerHTML;
    this.mealCost = document.querySelector('.mealplan__footer-summary .mealplan__cost > .price');
    this.activeWeek = activeWeek;
    this.activeWeekContainer = document.querySelector('.mealplan__week[data-week="1"]');
    this.subscribeBox = document.getElementById('subscribe');
    this.subscribed = true;
    this.meals = {
      breakfast: false,
      lunch: false,
      dinner: false,
      snacks: false
    }

    var self = this;

    document.querySelectorAll('.btn--week').forEach(function(weekBtn) {
      weekBtn.addEventListener('click', self.switchWeek.bind(self));
    });

    var caloriesSelectors = document.querySelectorAll('.calories__selector select');
    if (caloriesSelectors) {
      caloriesSelectors.forEach(function(caloriesSelector) {
        caloriesSelector.addEventListener('change', self.loadSelectedMealplan.bind(self));
      });
    }

    document.querySelectorAll('[data-add-meal]').forEach(function(btn) {
      btn.addEventListener('click', self.addMealPlan.bind(self));
    });

    document.querySelectorAll('[data-remove-meal]').forEach(function(btn) {
      btn.addEventListener('click', self.removeMealPlan.bind(self));
    });

    if (this.addMealPlanBtn) {
      this.addMealPlanBtn.addEventListener('click', self.addMealPlanToCart.bind(self));
    }

    this.$mealList.each(function(index, elem) {
      // Find the arrows for each slide show so that we're extra specific and not attaching to the arrows of another slideshow
      var nextArrow = $(elem).parent().find('.arrow.arrow--next');
      var prevArrow = $(elem).parent().find('.arrow.arrow--prev');
      var $dots = $(elem).parent().find('.meal__list--count');

      // Slick initialise event
      $(elem).on('init', function(evt, slick) {
        var $this = $(this);
        $(elem).css({'visibility': 'visible'});
        slideCount = $(elem).find('.product-card').length;
        var slidesShowing = slick.currentSlide + slick.options.slidesToShow;
        if (slick.slideCount < slick.options.slidesToShow) {
          slidesShowing = slick.slideCount;
        }
        // var slidesToShow = $(elem).slick('slickGetOption', 'slidesToShow');
        $dots.html((slidesShowing) + '/' + slick.slideCount);
      });

      // Initialise Slick
      $(elem).slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        nextArrow: nextArrow,
        prevArrow:  prevArrow,
        infinite: false,
        responsive:[
          {
            breakpoint: 1150,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '40px',
              infinite: true
            }
          }
        ]
      });

      // Update slide counter on change
      $(elem).on('afterChange', function(evt, slick, currentSlide) {
        var previousDifference = parseInt($dots.html().split('/')[0], 10);
        var difference = currentSlide + slick.options.slidesToShow;
        if (difference > slick.slideCount) {
          difference = slick.slideCount;
        }
        $dots.html(difference +' / '+ slick.slideCount);
      });
    });

    $('.mealplan__footer-meals').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      mobileFirst: true,
      centerMode: true,
      infinite: true,
      centerPadding: '20px',
      responsive: [
        {
          breakpoint: 480,
          settings: "unslick"
        }
      ]
    });

    if (this.addMealPlanBtn && this.mealCost) {
      this.renderPage();
    }
  }

  MealPlanSet.prototype.renderPage = function() {
    var mealTypes = Object.keys(this.meals);
    var footer = document.querySelector('.mealplan__footer');
    var self = this;
    var totalPrice = 0;
    var totalMeals = 0;
    var meals = {};
    mealTypes.forEach(function(mealType) {
      var summaryContainer = footer.querySelector('[data-meal-summary="' + mealType + '"]');
      var subscriptionProduct = self.subscriptions[mealType];
      if (!summaryContainer) return;
      var summaryMeals = summaryContainer.querySelectorAll('.selected-meal');

      // Early return in case the meal plan hasn't been selected yet.
      if (!self.meals[mealType]) {
        summaryMeals.forEach(function(summary, summaryIndex) {
          summary.style.backgroundImage = '';

          if ((summaryIndex+1) === summaryMeals.length) {
            var addBtns = document.querySelectorAll('[data-add-meal="' + mealType + '"]');
            var removeBtns = document.querySelectorAll('[data-remove-meal="' + mealType + '"]');
            addBtns.forEach(function(btn) { btn.style.display = 'inline-block'; });
            removeBtns.forEach(function(btn) { btn.style.display = 'none'; });
          }
        });
        return;
      }

      var selectedMeals = document.querySelectorAll('.mealplan__week--active .meal--' + mealType + ' .product-card');
      meals[mealType] = [];
      selectedMeals.forEach(function(productCard) {
        var productId = parseInt(productCard.dataset.productId, 10);
        var product = self.productInfo[mealType].find(function(product) { return product.id === productId });
        meals[mealType].push(product);
      });

      var summaryContainer = footer.querySelector('[data-meal-summary="' + mealType + '"]');
      if (!summaryContainer) return;
      var summaryMeals = summaryContainer.querySelectorAll('.selected-meal');
      var products = meals[mealType];
      summaryMeals.forEach(function(summary,summaryIndex) {
        var product = products[summaryIndex];
        if (!product) {
          return;
        }
        summary.style.backgroundImage = 'url(' + product.images[0] + ')';
        summary.style.backgroundSize = 'cover';
      });
      self.meal_count += products.length;
      // Update the cost of the total.
      totalPrice += subscriptionProduct.price;
      totalMeals += products.length;
      var addBtns = document.querySelectorAll('[data-add-meal="' + mealType + '"]');
      var removeBtns = document.querySelectorAll('[data-remove-meal="' + mealType + '"]');
      addBtns.forEach(function(btn) { btn.style.display = 'none'; });
      removeBtns.forEach(function(btn) { btn.style.display = 'inline-block'; });
    });
    if (this.mealCost) {
      this.mealCost.innerHTML = Shopify.formatMoney(totalPrice, "${{amount}}");
    }
    if (totalMeals >= this.min_meals) {
      if (this.addMealPlanBtn) {
        this.addMealPlanBtn.disabled = false;
      }
    } else {
      if (this.addMealPlanBtn) {
        this.addMealPlanBtn.disabled = true;
      }
    }

  }

  // If we've reached the maximum number of meals for this type then we need to disable the meal types.
  MealPlanSet.prototype.disableMealType = function(mealType) {
    var mealList = document.querySelector('.meal[data-meal-type="' + mealType + '"]');
    mealList.querySelectorAll('.product-card').forEach(function(productCard) {
      productCard.classList.add('product-card--added');
      productCard.querySelector('.product-details--added').style.display = "block";
    });
  }

  // If someone removed a mealType and they've reached the max then we should reenable it
  MealPlanSet.prototype.enableMealType = function(mealType) {
    var mealList = document.querySelector('.meal[data-meal-type="' + mealType + '"]');
    mealList.querySelectorAll('.product-card--added').forEach(function(productCard) {
      productCard.classList.remove('product-card--added');
      productCard.querySelector('.product-details--added').style.display = "none";
    });
  }

  // Hide the current week and show the next week.
  // We reset all values in here.
  MealPlanSet.prototype.switchWeek = function(event, toWeek) {
    var week = toWeek;
    if (event) {
      event.preventDefault();
      week = parseInt(event.target.dataset.week, 10);
      var button = event.target;
      if (button.classList.contains('btn--week-active')) {
        return;
      }
    }
    var currWeekBtn = document.querySelector('.btn--week-active');
    var nextWeekBtn =  document.querySelector('.btn--week[data-week="' + week + '"]')
    currWeekBtn.classList.remove('btn--primary');
    currWeekBtn.classList.remove('btn--week-active');
    currWeekBtn.classList.add('btn--secondary');
    nextWeekBtn.classList.remove('btn--secondary');
    nextWeekBtn.classList.add('btn--week-active');
    nextWeekBtn.classList.add('btn--primary');
    document.querySelector('div[data-week="' + this.activeWeek + '"]').classList.remove('mealplan__week--active');
    document.querySelector('div[data-week="' + week + '"]').classList.add('mealplan__week--active');
    this.activeWeek = week;
    this.activeWeekContainer.classList.remove('mealplan__week--active');
    this.activeWeekContainer = document.querySelector('.mealplan__week[data-week="' + this.activeWeek + '"]');
    this.activeWeekContainer.classList.add('mealplan__week--active');
    this.$mealList.slick('setPosition');
    this.renderPage();
  }

  MealPlanSet.prototype.removeMealPlan = function(event, type) {
    var mealType = type;
    if (event) {
      event.preventDefault();
      var target = event.target.closest('button');
      mealType = target.dataset.removeMeal;
    }
    this.meals[mealType] = false;
    this.enableMealType(mealType);
    this.renderPage();
  }

  MealPlanSet.prototype.addMealPlan = function(event, type) {
    var mealType = type;
    if (event) {
      event.preventDefault();
      var target = event.target.closest('button');
      mealType = target.dataset.addMeal;
    }
    // We need to add the images for the mealplans into each week and set the mealtype to true.
    this.meals[mealType] = true;
    this.disableMealType(mealType);
    this.renderPage();

  }
  // Add individual meals to the cart if the customer only wants to subscribe for one week.
  MealPlanSet.prototype.addMealsToCart = function() {
    var self = this;
    var properties = { 'week': this.activeWeek, mealPlan: this.mealPlan, mealPlanTitle: this.mealPlanTitle };
    if (this.calories > 0) {
      properties['calories'] = this.calories;
    }
    var products = [];
    // We need to get each meal that's been selected for the week.
    Object.keys(this.meals).forEach(function(meal) {
      if (!self.meals[meal]) {
        // We can skip this meal because we don't need to add it.
        return
      }
      var weekContainer = document.querySelector('.mealplan__week[data-week="' + self.activeWeek + '"]');
      var mealContainer = weekContainer.querySelector('[data-meal-type="' + meal + '"]');
      var productCards = mealContainer.querySelectorAll('.product-card');
      productCards.forEach(function(product) {
        var productId = parseInt(product.dataset.productId, 10);
        var product = self.productInfo[meal].find(function(product) { return product.id === productId });
        if (product) {
          products.push(product.variants[0].id);
        }
      });

    });

    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: {id: products, properties: properties },
      dataType: 'json',
      success: function(response) {
        self.postAddToCart();
      }
    });
  }

  MealPlanSet.prototype.addMealPlanToCart = function(event) {
    event.preventDefault();
    var mealTypes = Object.keys(this.meals);
    var queue = [];
    var self = this;
    var properties = { mealPlan: this.mealPlan };
    var products = []
    properties['calories'] = 1200;
    properties['week'] = this.activeWeek;
    if (this.calories > 0) {
      properties['calories'] = this.calories;
    }

    function processQueue() {
      var item = queue.pop();

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: item,
        dataType: 'json',
        success: function(response) {
          if (queue.length) {
            processQueue();
          } else {
            self.postAddToCart();
          }
        }
      });
    }

    mealTypes.forEach(function(mealType) {
      var meal = self.meals[mealType];
      if (!meal) return;
      var productProperties = Object.assign({}, properties);
      var subscription = self.subscriptions[mealType]
      productProperties['subscription_id'] = subscription.subscription_id;
      productProperties['shipping_interval_frequency'] = subscription.shipping_interval_frequency;
      productProperties['shipping_interval_unit_type'] = subscription.shipping_interval_unit_type;
      productProperties['meal'] = mealType;
      var data = {
        id: self.subscriptions[mealType].product_id,
        quantity: 1,
        properties: productProperties
      };
      queue.push(data);
    });
    processQueue();
  }

  MealPlanSet.prototype.postAddToCart = function() {
    ajaxCart.load();
    // this.switchWeek(null, this.activeWeek+1);
  };

  MealPlanSet.prototype.loadSelectedMealplan = function(event) {
    var selectElement = event.target;
    var selectedCalories = selectElement.options[selectElement.selectedIndex].value;
    window.location = window.location.origin + window.location.pathname + '?view=mealplan-set&cache=false&calories=' + selectedCalories;
  }

  return MealPlanSet;
})();
